import { render, staticRenderFns } from "./Why.vue?vue&type=template&id=d4503bea&scoped=true&"
import script from "./Why.vue?vue&type=script&lang=ts&"
export * from "./Why.vue?vue&type=script&lang=ts&"
import style0 from "./Why.vue?vue&type=style&index=0&id=d4503bea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4503bea",
  null
  
)

export default component.exports